module.exports = __webpack_public_path__ + "img/qr-scan-1.21246a2e.png";